import React from 'react';
import { Monitor, Gamepad2, Trophy, Network, Code, Video } from 'lucide-react';
import { CyberCard } from './ui/CyberCard';
const services = [{
  title: 'High-Performance Rigs',
  price: '£8 / hour',
  icon: Monitor,
  description: 'RTX 4090 powered stations with 360Hz monitors for zero-latency dominance.',
  color: 'cyan'
}, {
  title: 'VR Immersion',
  price: '£15 / hour',
  icon: Gamepad2,
  description: 'Full-body haptic feedback suits and latest gen headsets. Reality is optional.',
  color: 'purple'
}, {
  title: 'Esports Tournaments',
  price: '£20 / entry',
  icon: Trophy,
  description: 'Weekly competitions with cash prizes. Prove your worth in the arena.',
  color: 'green'
}, {
  title: 'LAN Parties',
  price: '£40 / night',
  icon: Network,
  description: 'All-night lock-ins with gigabit networking and dedicated servers.',
  color: 'cyan'
}, {
  title: 'Game Dev Workshops',
  price: '£25 / session',
  icon: Code,
  description: 'Learn Unity & Unreal Engine from industry veterans in our dev lab.',
  color: 'purple'
}, {
  title: 'Streaming Pods',
  price: '£12 / hour',
  icon: Video,
  description: 'Soundproof studios equipped with pro audio, lighting, and capture cards.',
  color: 'green'
}] as const;
export function Services() {
  return <section id="services" className="py-24 bg-cyber-black relative" data-id="element-151">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <div className="text-center mb-16" data-id="element-153">
          <h2 className="text-4xl md:text-5xl font-orbitron font-bold text-white mb-4" data-id="element-154">
            <span className="text-cyber-purple" data-id="element-155">SYSTEM</span> SERVICES
          </h2>
          <div className="h-1 w-24 bg-cyber-cyan mx-auto shadow-[0_0_10px_#00f0ff]" data-id="element-156" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-157">
          {services.map((service, index) => <CyberCard key={service.title} delay={index * 0.1} glowColor={service.color} className="p-8 h-full flex flex-col" data-id="element-158">
              <div className={`
                w-16 h-16 rounded-lg mb-6 flex items-center justify-center
                bg-${service.color === 'cyan' ? 'cyber-cyan' : service.color === 'purple' ? 'cyber-purple' : 'cyber-green'}/10
                text-${service.color === 'cyan' ? 'cyber-cyan' : service.color === 'purple' ? 'cyber-purple' : 'cyber-green'}
              `} data-id="element-159">
                <service.icon className="w-8 h-8" data-id="element-160" />
              </div>

              <h3 className="text-2xl font-orbitron font-bold text-white mb-2" data-id="element-161">
                {service.title}
              </h3>
              <div className="text-xl font-rajdhani font-bold text-cyber-yellow mb-4" data-id="element-162">
                {service.price}
              </div>
              <p className="text-gray-400 font-rajdhani text-lg leading-relaxed flex-grow" data-id="element-163">
                {service.description}
              </p>

              <button className={`
                mt-6 w-full py-2 border border-dashed border-gray-600 
                hover:border-${service.color === 'cyan' ? 'cyber-cyan' : service.color === 'purple' ? 'cyber-purple' : 'cyber-green'} 
                hover:text-${service.color === 'cyan' ? 'cyber-cyan' : service.color === 'purple' ? 'cyber-purple' : 'cyber-green'}
                text-gray-500 font-orbitron text-sm transition-colors uppercase tracking-wider
              `} data-id="element-164">
                Book Slot
              </button>
            </CyberCard>)}
        </div>
      </div>
    </section>;
}